export default __webpack_public_path__ + "static/media/sensotrend_connect_select_uploader.efb6460c.png";